import {
  useGetProductDetailsMeshQuery,
  type GetProductDetailsMeshQueryVariables,
} from 'domains/products/api'

export const useGetProductDetailsMesh = (variables: GetProductDetailsMeshQueryVariables) => {
  const {
    data,
    error: apiError,
    loading: apiLoading,
    refetch: apiRefetch,
  } = useGetProductDetailsMeshQuery({
    variables,
  })

  return {
    productDetails: data?.catalogToolsApiServiceGetRetailerProductData?.retailerProductData?.[0],
    apiError,
    apiLoading,
    apiRefetch,
  }
}
